/**
 * Spiegel von `istInterneRoute` in apps/api/src/ticket/ticket.regeln.ts: nur
 * interne, relative Pfade dürfen als `<Link to>` gerendert werden.
 * react-router behandelt ein Ziel, das mit `//` beginnt, als protokollrelative
 * — also externe — URL (offener Redirect); `javascript:` scheitert schon am
 * fehlenden führenden „/". `/\evil` wird von manchen Browsern beim
 * Normalisieren wie `//evil` behandelt (Backslash ≈ Slash), deshalb auch das
 * ablehnen. Ohne diese Prüfung wäre eine gespeicherte `route` gespeicherter
 * XSS/Open-Redirect, sobald sie ungeprüft in `<Link to>` landet.
 */
export function istInterneRoute(route: string | null | undefined): route is string {
  return (
    typeof route === "string" &&
    route.startsWith("/") &&
    !route.startsWith("//") &&
    !route.startsWith("/\\")
  );
}
